import { CrudManager } from "./crud";

const fields = [
  { key: "name", label: "Nombre interno", type: "text" },
  { key: "title", label: "Título", type: "i18n" },
  { key: "subtitle", label: "Subtítulo", type: "i18n" },
  { key: "image_desktop", label: "Imagen escritorio", type: "media" },
  { key: "image_mobile", label: "Imagen móvil", type: "media" },
  { key: "cta", label: "Texto CTA", type: "i18n" },
  { key: "url", label: "URL destino", type: "text" },
  { key: "priority", label: "Prioridad", type: "number" },
  { key: "active", label: "Activo", type: "switch" },
];

const columns = [
  { key: "name", label: "Nombre" },
  { key: "title", label: "Título" },
  { key: "priority", label: "Prioridad" },
  { key: "active", label: "Activo" },
];

export default function BannersAdmin() {
  return <CrudManager coll="banners" title="Banners" fields={fields} columns={columns} testid="banners-admin" />;
}
